import AlternativeCard from './AlternativeCard'

export default AlternativeCard
